// Size threshold above which locally-parsed geospatial files (KML/KMZ/GeoJSON/GPX/TopoJSON)
// skip client-side download/rendering to avoid blocking the UI thread. Does not apply to
// Shapefile (.zip), whose preview is always bounded/simplified server-side regardless of size.
export const MAX_LOCAL_PARSE_PREVIEW_BYTES = 30 * 1024 * 1024;
